

// Components
import Banner from "../Components/Banner";
import FutureOilOverview from "../Components/FutureOilOverview";
import KeyTopics from "../Components/KeyTopics";
import FeatureSection from "../Components/FeatureSection";
import SpeakersSection from "../Components/SpeakerSection";
import Pagehelmet from "./Pagehelmet";


const Home = () => {
  return (
    <div>
      {/* Page Helmet for SEO & Page Title */}
      <Pagehelmet pageTitle="Home" />

      {/* ================= Banner Section ================= */}
      <Banner/>
      {/* ================= Banner Section End ================= */}

      {/* ================= FutureOil Overview Section ================= */}
      <FutureOilOverview/>
      {/* ================= FutureOil Overview Section End ================= */}

      {/* ================= Key Topics Section ================= */}
      <KeyTopics />
      {/* ================= Key Topics Section End ================= */}

      {/* ================= Feature Section ================= */}
      <FeatureSection />
      {/* ================= Feature Section End ================= */}

      {/* ================= Speakers Section ================= */}
      <SpeakersSection />
      {/* ================= Speakers Section End ================= */}
    </div>
  );
};

export default Home;
